/**
 *
 * CommunicationReminder
 *
 */

import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

import { useParams } from "react-router-dom";

// components
import TCFModal from "components/TCFModal";
import { NotificationSimple } from "components/Notifications";

import api from "utils/api";
// hooks
import { useAsync } from "utils/hooks";
// utils
import { getObjId } from "utils/helpers/helper.general";

function CommunicationReminder({
  open,
  isReminderLoading,
  // actions
  setOpen,
  setIsReminderLoading,
  onResult,
  // default props
  className,
}) {
  const childClassNames = classNames("reminder-wrapper", className);
  const { t } = useTranslation();

  const { id: initId } = useParams();

  const { isLoading, isSuccess, run, data, reset } = useAsync();

  const newKey = "new";

  const [initialID, setInitialID] = useState(false);

  // Because history not trigger update component
  useEffect(() => {
    if (!!initId && initId != newKey) {
      setInitialID(initId);
    }
  }, [initId]);

  useEffect(() => {
    setIsReminderLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (!!data && !isLoading && !!onResult) {
      // result : studentsFinal, result
      const { studentsFinal, result } = data;
      let resultData = [];
      result?.map(res => {
        const hasSuchStdIndex = resultData.findIndex(
          r => getObjId(r?.student) == getObjId(res?.response?.student),
        );
        if (hasSuchStdIndex !== -1) {
          resultData[hasSuchStdIndex] = {
            ...resultData[hasSuchStdIndex],
            status: res?.result?.notification?.status,
          };
        } else {
          resultData.push({
            student: res?.response?.student,
            recipients: res?.response?.recipients,
            status: res?.result?.notification?.status,
          });
        }
      });
      onResult(resultData);
    }
  }, [data]);

  const onCancelModalHandler = useCallback(() => {
    !!setOpen && setOpen(false);
  }, [setOpen]);

  const onAddElementHandler = useCallback(() => {
    !isLoading && run(api.communications.remindCommunication(initialID));
    !!setOpen && setOpen(false);
  }, [initialID, setOpen, isLoading]);

  return (
    <>
      <NotificationSimple
        Loading={isLoading}
        Successful={isSuccess}
        message={t("notifications.during")}
        messageSuccess={t("notifications.successfulRelaunch")}
        description=""
      />
      <TCFModal
        className={childClassNames}
        open={open}
        setOpen={setOpen}
        title={t("news.boostingStudents")}
        submitName={t("common.relancer")}
        loading={isLoading}
        confirmLoading={isSuccess}
        onCancel={onCancelModalHandler}
        onOk={onAddElementHandler}
      >
        <p>
          {t("news.boostingStudentsMsg")} :
        </p>
      </TCFModal>
    </>
  );
}

CommunicationReminder.defaultProps = {
  open: false,
  loading: false,
  confirmLoading: false,
};

export default CommunicationReminder;
